import React, {Component} from 'react';
import Form from './form';
import request from '../request';
import GroupsContainer from './groups_container';
import ReferenceStarsRating from './reference_stars_rating';
import Loading from './loading';
import Markdown from './markdown';
import * as Inflector from 'inflected';

import {PopulationSizes, TrialSearchKey, InterventionSearchKey, ReferenceTherapyTypes, ReferenceTypes, ReferenceResultsData} from '../constants.js.erb';

export default class ReferencesForm extends Component {
  constructor(props) {
    super(props);
    let {reference} = props;
    this.state = {reference, errors: {}};
    this.onChangeField = this.onChangeField.bind(this);
    this.submit = this.submit.bind(this);
  }

  submit(e) {
    e.preventDefault();
    this.setState({submitting: true});
    let {reference} = this.state;

    let url = "/admin/references";
    let method;


    if (reference.id) {
      url += "/" + reference.id;
      method = "PUT"
    } else {
      method = "POST"
    }

    let model = {};
    let fields = this.fields();
    for (let field of fields) {
      model[field.name] = reference[field.name];
    }

    request(method, url, {reference: model}).then(reference => {
      let {onCreate} = this.props;
      if (onCreate) {
        onCreate(reference);
        return;
      } else if (method === 'POST') {
        window.location = "/admin/references/" + reference.id;
      }
      this.setState({errors: [], submitting: false, abstract_changed: false});
    }).catch(({errors}) => {
      this.setState({errors, submitting: false});
    });
  }

  onChangeField(name, value) {
    let {reference} = this.state;
    reference[name] = value;
    let changes = {reference}

    if (name === 'abstract_text') {
      changes.abstract_changed = true;
    }
    this.setState(changes);
  }


  fields() {
    let {abstract_changed} = this.state;
    let extraOptions = ReferenceStarsRating.EXTRA_OPTIONS;

    return [
      {name: 'results_data', type: 'select', label: 'Scoreable Results Data?', collection: ReferenceResultsData, allowBlank: true, hint: 'Must set to rate or add notes'},
      {name: 'reference_type', type: 'select', collection: ReferenceTypes},
      {name: 'name', label: 'Title', hint: 'Source Name', required: true},
      {name: 'doi', label: 'DOI', type: 'string-with-link', showLink: true, linkTemplate: 'https://doi.org/{id}'},
      {name: 'source_link'},
      {name: 'reference_year'},
      {name: 'study_trial_id', label: 'Study NCT', type: 'remote-select2', src: "/admin/trials/as_options.json",
       search_key: TrialSearchKey, hint: 'This is the NCT on which this reference and its data are based.', showLink: true, linkTemplate: '/admin/trials/{id}'},

      {name: 'abstract_text', type: 'text', rows: 6, autosize: true},
      {name: 'auto_import', label: 'Imported automatically', type: ImportedInformation,  disabled: true, visible: r => r.auto_import},
    ];
  }

  render() {
    let {reference, errors, submitting} = this.state;
    let {onCancel} = this.props;
    return (
      <>
        <div className="well">
          <Form id="references_form" model_name="Reference" prefix="reference" fields={this.fields()} model={reference} errors={errors} submitting={submitting} onChangeField={this.onChangeField} onSubmit={this.submit} onCancel={onCancel} />
        </div>
      </>
    )
  }
}


class ImportedInformation extends Component {
  render() {
    let {model} = this.props;
    let label = Inflector.titleize(model.import_source);
    return (
      <p className="help-text"><i>Imported from <b>{label}</b></i></p>
    )
  }
}
